<script setup lang="ts">
import { Link } from '@inertiajs/vue3'
import BlockSection from './BlockSection.vue'
import { GenderMenuBlock } from '@interfaces/menu.interface'

defineProps<{
    block: GenderMenuBlock,
}>()

const colorStyle = (type: string) => {
    const colors = {
        men: 'bg-grayscale-50 text-primary-700',
        women: 'bg-pink-50 text-pink-700',
        kids: 'bg-mint-50 text-mint-700',
    }

    return colors[type] || 'bg-grayscale-50 text-grayscale-700'
}
</script>

<template>
    <BlockSection :title="$t('components.menu.catalog.gender')">
        <ul class="space-y-1.5">
            <li
                v-for="(item, itemIdx) in block.items"
                :key="itemIdx"
            >
                <Link
                    :href="item.url"
                    class="flex items-center group"
                >
                <div :class="['flex items-center justify-center mr-2 font-medium rounded-lg w-9 h-9 shrink-0 text-p2 select-none', colorStyle(item.type)]">
                    {{ item.name.charAt(0) }}
                </div>
                <span class="truncate text-grayscale-800 group-hover:text-primary-800">{{ item.name }}</span>
                </Link>
            </li>
        </ul>
    </BlockSection>
</template>
